import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { Question } from '@/models/Question';
import { Report } from '@/models/Report';
import Questionnaire from '@/components/Questionnaire/Questionnaire.vue';
import _ from 'lodash';
import { Answer } from '@/models/Answer';

@Component<OverwriteAssignmentValueDialog>({
  components: {
    Questionnaire,
  },
})
export default class OverwriteAssignmentValueDialog extends Vue {
  @Prop()
  protected report!: Report;

  protected questions: Question[] = [];

  protected isLoading = true;

  protected answerPayloads: Record<string, string>[] = [];

  protected async mounted(): Promise<void> {
    await this.fetchQuestions();
    this.isLoading = false;
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected async fetchQuestions(): Promise<void> {
    this.questions = await new Question().filter({ section: 'overwrite_value_modal' }).all()
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected async saveAnswers(): Promise<void> {
    const answers = this.answerPayloads.map(async (answerPayload) => await this.saveReportAnswer(answerPayload));
    await Promise.all(answers);
    this.assignmentValueUpdated();
    this.close();
  }

  protected async saveReportAnswer(payload: Record<string, string>): Promise<void> {
    await new Answer()
      .create(payload)
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected handleEmitAnswer(payload: Record<string, string>): void {
    const index = _.findIndex(this.answerPayloads, { question: payload.question });
    if (index !== - 1) {
      this.answerPayloads[index] = payload;
      this.answerPayloads = this.answerPayloads.filter((indexed: Record<string, string>) => indexed.value !== '');
      return;
    }

    this.answerPayloads.push(payload);
  }

  protected get isValid(): boolean {
    return this.answerPayloads.length === 2;
  }

  @Emit()
  protected assignmentValueUpdated(): string {
    return '';
  }
}
